import React from 'react';
import PageError from '../../components/pageError';

const ErrorPage = () => (
	<PageError
		title="500, kerfisvilla"
		text="Einhver dularfull kerfisvilla virðist hafa komið upp." />
);

export default ErrorPage;
